import type { PlayerType } from "@/shared/types/flash";
import styles from "./FlashPlayer.module.css";

interface FlashPlayerHeaderProps {
  gameTitle: string;
  onExit: () => void;
  mode: PlayerType | "iframe" | null;
  availablePlayers: {
    ruffle: boolean;
    flash: boolean;
  };
  onModeChange: (mode: PlayerType | "iframe") => void;
}

export function FlashPlayerHeader({
  gameTitle,
  onExit,
  mode,
  availablePlayers,
  onModeChange,
}: FlashPlayerHeaderProps) {
  return (
    <div className={styles.header}>
      <button className={styles.backButton} onClick={onExit}>
        ← Назад к списку
      </button>
      <h2>{gameTitle}</h2>
      {mode !== "iframe" && (
        <div className={styles.modeSwitcher}>
          <button
            className={`${styles.modeButton} ${
              mode === "ruffle" ? styles.active : ""
            }`}
            onClick={() => onModeChange("ruffle")}
            disabled={!availablePlayers.ruffle}
            title={
              availablePlayers.ruffle
                ? "Ruffle - WebAssembly плеер (рекомендуется)"
                : "Ruffle недоступен"
            }
          >
            🎮 Ruffle
          </button>
          <button
            className={`${styles.modeButton} ${
              mode === "flash" ? styles.active : ""
            }`}
            onClick={() => onModeChange("flash")}
            disabled={!availablePlayers.flash}
            title={
              availablePlayers.flash
                ? "Flash - Нативный Flash Player"
                : "Flash плагин не установлен"
            }
          >
            ⚡ Flash
          </button>
        </div>
      )}
    </div>
  );
}
